import { useEffect, useRef } from 'preact/hooks';
import { ColorEngine } from '../services/colorEngine.js';

export function useTheme(hostEl, cfg) {
  const engineRef = useRef(null);

  useEffect(() => {
    if (!hostEl || !cfg) return;
    const applyTheme = (theme) => {
      const cfgWithTheme = theme ? { ...cfg, theme } : cfg;
      const engine = new ColorEngine(cfgWithTheme);
      engine.applyTo(hostEl);
      engineRef.current = engine;
    };

    if (cfg.theme === 'auto') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const handler = () => applyTheme(mq.matches ? 'dark' : 'light');
      applyTheme(mq.matches ? 'dark' : 'light');
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    } else {
      applyTheme(null);
    }
  }, [hostEl, cfg]);

  const setColor = (property, value) => {
    if (hostEl && engineRef.current) {
      engineRef.current.setColor(property, value, hostEl);
    }
  };

  return { setColor };
}
